import { Injectable, Predicate } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as selector from './account.selector';
import { AccountFilter } from '../models/account.filter';
import { Account } from '../models/account';
import {
  FetchAccounts,
  AddTotalCount,
  AddError,
  RemoveAccountFilter,
  AddAccountFilter,
  GetAccountWallet,
  GetAccount,
  CreateAccount,
  ModifyAccount,
  SaveAccountWallet,
  AddSuccess,
  // SaveAccountCard,
  FetchCurrentAccounts,
  AddCurrentAccount,
  AddOrUpdateCurrentAccount,
  SaveKycDocument,
  FetchKycDocument,
  SubmitKycDocument,
  SaveBankIbanNumber,
} from './account.action';
import { Wallet } from '../models/wallet';
//import { CardRegister } from 'src/app/modules/card/models/card.register';
import { KycDocument } from '../models/document';
import { BankAccount } from '../models/bank-account';
import { AccountState } from '@modules/account/store/account.state';

@Injectable()
export class AccountStoreService {
  constructor(private store: Store<AccountState>) {}

  public fetchAllAccount(
    search: string = '',
    pageIndex: number = 0,
    pageSize: number = 4,
    filter: AccountFilter
  ): void {
    this.store.dispatch(
      FetchAccounts({
        search: search,
        pageIndex: pageIndex,
        pageSize: pageSize,
        filter: filter,
      })
    );
  }

  public getAllAccounts(): Observable<Account[]> {
    return this.store.pipe(select(selector.getAllAccounts));
  }

  public fetchCurrentAccount(): void {
    this.store.dispatch(FetchCurrentAccounts());
  }

  public getAccountByUserId(userId: string): Observable<Account> {
    return this.store.select(selector.getAccountBySearch((x) => x.userId === userId));
  }

  public registerAccount(account: Account): void {
    this.store.dispatch(CreateAccount({ account: account }));
  }

  public updateAccount(id: string, updated: Partial<Account>): void {
    this.store.dispatch(ModifyAccount({ id: id, update: updated }));
  }

  public fetchAccountById(id: string): void {
    this.store.dispatch(GetAccount({ id: id }));
  }

  public getAccountById(id: string): Observable<Account> {
    return this.store.select(selector.getAccountById(id));
  }

  public addTotalCount(data: number): void {
    this.store.dispatch(AddTotalCount({ totalCount: data }));
  }

  public getTotalCount(): Observable<number> {
    return this.store.select(selector.getTotalCount);
  }

  public loadError(error: any): void {
    this.store.dispatch(AddError(error));
  }

  public setAccountFilter(filter: AccountFilter): void {
    this.store.dispatch(AddAccountFilter({ filter: filter }));
  }

  public getAccountFilter(): Observable<AccountFilter> {
    return this.store.select(selector.getAccountFilter);
  }

  public getCurrentAccount(filter?: Predicate<Account>): Observable<Account> {
    return this.store.select(selector.getCurrentAccountBySearch(filter));
  }

  public getBusinessAccount(): Observable<Account> {
    return this.store.select(selector.getBusinessAccount);
  }

  public getProviderBusinessAccount(): Observable<Account> {
    return this.store.select(selector.getProviderBusinessAccount)
  }

  public removeAccountFilter(): void {
    this.store.dispatch(RemoveAccountFilter());
  }

  public getAccountsByFilter(filter: Predicate<Account>): Observable<Account[]> {
    return this.store.select(selector.getAccountByFilter(filter));
  }

  public getAccountByFilter(filter: Predicate<Account>): Observable<Account> {
    return this.store.select(selector.getAccountBySearch(filter));
  }

  public getAccountWallet(accountId: string, provider: string, providerId: string): void {
    this.store.dispatch(GetAccountWallet({ id: accountId, provider: provider, providerId: providerId }));
  }

  public saveWallet(accountId: string, wallet: Wallet): void {
    this.store.dispatch(SaveAccountWallet({ id: accountId, wallet: wallet }));
  }

  /*public saveCard(accountId: string, card: CardRegister): void {
    this.store.dispatch(SaveAccountCard({ id: accountId, cardRegister: card }));
  }*/

  public addCurrentAccount(current: Account[]): void {
    this.store.dispatch(AddCurrentAccount({ accounts: current }));
  }

  public addOrUpdateCurrentAccount(current: Account): void {
    this.store.dispatch(AddOrUpdateCurrentAccount({ account: current }));
  }

  public AddSuccess(): void {
    this.store.dispatch(AddSuccess());
  }

  public saveKycDocument(accountId: string, kycDocument: KycDocument): void {
    this.store.dispatch(SaveKycDocument({ accountId, kycDocument }));
  }

  public fetchKycDocument(accountId: string): void {
    this.store.dispatch(FetchKycDocument({ accountId }));
  }

  public getKycDocument(): Observable<KycDocument[]> {
    return this.store.select(selector.getKycDocuments);
  }

  public submitKycDocument(accountId: string, documentRef: string): void {
    this.store.dispatch(SubmitKycDocument({ accountId, documentRef }));
  }

  public saveBankIbanNumber(accountId: string, token: string): void {
    this.store.dispatch(SaveBankIbanNumber({ accountId, token }));
  }

  public getBankAccounts(): Observable<BankAccount[]> {
    return this.store.select(selector.getBankAccount);
  }
}
